// services/claimService.ts
import { AxiosError } from "axios";
import apiClient from "./apiClient";
import { getAuthHeader } from "@utils/getAuthHeader";
import serviceConfig from "config/serviceConfig";

export interface ClaimPayload {
	user_id?: number;
	company_id?: number;
	name?: string;
	email?: string;
	phone?: string;
	address?: string;
	company_name?: string;
	subject?: string;
	description?: string;
	additional_details?: string;
	claim_type?: string; // e.g. "damage_report"
	urgency_level?: number; // 1..5
	meta?: string;
	meta2?: string;
	meta3?: string;
}

export interface ClaimResponse<T = any> {
	message: string;
	success: boolean;
	data: T | null;
	errorMsg?: string;
}

const compactBody = <T extends Record<string, any>>(obj: T): Partial<T> => {
	const out: Partial<T> = {};
	Object.entries(obj).forEach(([k, v]) => {
		if (v !== undefined && v !== null && v !== "") (out as any)[k] = v;
	});
	return out;
};

/**
 * Create a new claim
 * POST /texapp/claim/new/
 */
export const createClaim = async <T = any>(
	payload: ClaimPayload,
): Promise<ClaimResponse<T>> => {
	try {
		const res = await apiClient.post<ClaimResponse<T>>(
			serviceConfig.routes.claimNew,
			compactBody(payload),
			{
				headers: {
					Authorization: getAuthHeader(),
					"Content-Type": "application/json",
				},
			},
		);
		return res.data;
	} catch (err) {
		if (err instanceof AxiosError) {
			throw new Error(err.response?.data?.message || "Failed to create claim.");
		}
		throw new Error("Unknown error while creating claim.");
	}
};
